import { storageKeys } from 'config/settings.json';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

/**
 *
 * @param {{ app: Record<string, unknown>[]}} appInfo
 * @param {string} code language code
 * @param {number} appId app id
 */
export function UNSAFE_malformAppInfo(appInfo, code, appId) {
  const [app] = appInfo.app;

  const {
    landingVideo,
    language_display_name,
    left_graphic,
    center_graphic,
    bottom_graphic,
    logo,
    logo_white,
    logo_wide_color,
    logo_wide_white,
    primary_color,
    secondary_color,
    landing_quote,
    programBenefits,
    facebook,
    flickr,
    instagram,
    twitter,
    youtube,
    pinterest,
    googlePlus,
    linkedin,
    tikTok: tiktok,
    weibo,
    appName,
    appNameDevice,
    clientName,
    login_image,
    question_header,
    profile_image_header,
    google_play_url,
    apple_store_url,
    video_email_copy,
    video_email_subject,
    image_email_copy,
    image_email_subject,
    shareTitle,
    shareCopy,
    twitter_copy,
    welcome_page_copy,
    languages,
    feature_flags: featureFlags,
    sales_companion_apps,
    website_url: companyWebsite,
    client_id: clientId,
    client_secret: clientSecret,
    website_url: programUrl,
    train_learn_config: trainLearnConfig,
    clientWebsite,
    general_background_image: generalBackgroundImage,
    directory_url: directoryURL,
    custom_share_domain: customShareDomainRaw,
    introVideo,
    splashScreen,
    custom_css: customCSS,
    fast_track_app_id: fastTrackAppId,
    font,
    body_font: bodyFont,
    destination,
  } = app;

  const socials = {
    facebook: facebook !== '' ? facebook : null,
    flickr: flickr !== '' ? flickr : null,
    instagram: instagram !== '' ? instagram : null,
    twitter: twitter !== '' ? twitter : null,
    youtube: youtube !== '' ? youtube : null,
    pinterest: pinterest !== '' ? pinterest : null,
    googlePlus: googlePlus !== '' ? googlePlus : null,
    linkedin: linkedin !== '' ? linkedin : null,
    tiktok: tiktok !== '' ? tiktok : null,
    weibo: weibo !== '' ? weibo : null,
  };

  const companionDisplayNames = (sales_companion_apps || []).reduce((acc, item) => {
    const normalized = item.language.includes('_') ? item.language.replace('_', '-') : item.language;

    const corrected = normalized.includes('-')
      ? `${normalized.split('-')[0].toLowerCase()}-${normalized.split('-')[1].toUpperCase()}`
      : `${normalized.toLowerCase()}-${normalized.toUpperCase()}`;

    const display = item.language_display_name;

    if (display) acc[corrected] = display;
    return acc;
  }, {});

  const flags = featureFlags.filter((flag) => flag.is_enabled === true);

  const isEnGBDefault = flags.find((flag) => flag.name === 'en_gb_default_language');

  const defaultEnglish = isEnGBDefault
    ? { code: 'en-GB', country: 'UK English', langFile: 'gb' }
    : {
        code: 'en-US',
        country: (language_display_name && language_display_name.trim()) || 'Global English',
        langFile: 'en',
      };

  if (!code.includes('-')) {
    StorageHandler.save(storageKeys.lang, defaultEnglish);
  }

  let currentLanguage = code ? code : defaultEnglish.code;
  const salesCompanion = sales_companion_apps
    ? sales_companion_apps.filter(({ language: lan }) => lan === currentLanguage.replace('-', '_'))[0]
    : null;

  const currentAppId = appId ?? app.app_id ?? import.meta.env.VITE_APP_ID;
  const salesCompanionAppId = currentLanguage.includes('en') || !salesCompanion ? currentAppId : salesCompanion.id;

  return {
    appId: currentAppId,
    backgroundImage: generalBackgroundImage
      ? generalBackgroundImage.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    backgroundVideo: landingVideo
      ? landingVideo.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    loginImage: login_image ? login_image.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
    logo: logo ? logo.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
    logoWhite: logo_white ? logo_white.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
    logoWide: logo_wide_color
      ? logo_wide_color.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    logoWideWhite: logo_wide_white
      ? logo_wide_white.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    leftGraphic: left_graphic
      ? left_graphic.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    centerGraphic: center_graphic
      ? center_graphic.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    bottomGraphic: bottom_graphic
      ? bottom_graphic.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    primaryColor: primary_color !== '' ? primary_color : null,
    secondaryColor: secondary_color !== '' ? secondary_color : null,
    landingQuote: landing_quote !== '' ? landing_quote : null,
    appName: appName !== '' ? appName : null,
    appNameDevice: appNameDevice !== '' ? appNameDevice : null,
    clientName: clientName !== '' ? clientName : null,
    questionHeader: question_header
      ? question_header.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    profileImageHeader: profile_image_header
      ? profile_image_header.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
      : null,
    introVideo: introVideo ? introVideo.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
    programBenefits,
    socials,
    appleStore: apple_store_url,
    googlePlay: google_play_url,
    video_email_copy,
    video_email_subject,
    image_email_copy,
    image_email_subject,
    shareTitle,
    shareCopy,
    twitter_copy,
    welcomePageCopy: welcome_page_copy !== '' ? welcome_page_copy : null,
    featureFlags: flags,
    salesCompanionAppId,
    companyWebsite,
    clientId,
    clientSecret,
    clientWebsite,
    programUrl,
    trainLearnConfig,
    fastTrackAppId,
    splashScreen,
    customCSS,
    font,
    bodyFont,
    destination: destination && String(destination).trim() !== '' ? String(destination).trim() : null,
    directoryURL,
    customShareDomain:
      customShareDomainRaw && String(customShareDomainRaw).trim() !== '' ? String(customShareDomainRaw).trim() : null,
    languages: (() => {
      const apiLanguages = languages
        ? languages.map((lan) => {
            const correctedLan = lan.includes('-')
              ? `${lan.split('-')[0].toLowerCase()}-${lan.split('-')[1].toUpperCase()}`
              : `${lan.toLowerCase()}-${lan.toUpperCase()}`;

            const languageFile = lan.includes('-') ? lan.split('-')[0].toLowerCase() : lan.toLowerCase();

            const names = new Intl.DisplayNames(['en'], { type: 'region' });

            const country = companionDisplayNames[correctedLan] || names.of(correctedLan.split('-')[1].toUpperCase());

            return {
              code: correctedLan,
              langFile: languageFile,
              country,
            };
          })
        : [];

      const allLanguages = [defaultEnglish, ...apiLanguages.filter((lang) => lang.code !== defaultEnglish.code)];

      return allLanguages;
    })(),
  };
}

const AppSettings = async () => {
  const { code } = await StorageHandler.load(storageKeys.lang);
  const appId = await DataHandler.matchAppId();

  const lang = code ? code : '';

  const appInfo = await APIHandler.getAppInfo(appId, lang);

  if (appInfo) {
    const appInfoObject = UNSAFE_malformAppInfo(appInfo, code, appId);

    StorageHandler.save(storageKeys.appInfo, appInfoObject);

    return true;
  }
};

export default AppSettings;
